// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a070854493fd916fbecb470dd3f6ba72313ea0ec.chunk.js";
};